<template>
    <div class="panel-content">
        <h2>Medische Isotopen</h2>
        <p>Medische isotopen vormen het basisingrediënt van radiofarmaceutische producten, die gebruikt worden om onder andere hart- en vaatziekten en kankercellen mee op te sporen (diagnose) of te bestrijden (therapie). Het radiofarmaceutische product dat een patiënt uiteindelijk krijgt toegediend, bestaat uit twee componenten: medische isotopen en een tracer.</p>
        <a @click="trackLink" class="button" href="https://www.pallasreactor.com/medische-isotopen/wat-is-een-isotoop/" target="_blank">Meer informatie</a>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {
        methods: {
            trackLink()
            {
                window.dataLayer.push({ 'event': 'clickout', 'url': 'https://www.pallasreactor.com/medische-isotopen/wat-is-een-isotoop/' });
            }
        }
    };
</script>
